import React from 'react';
import '../../../styles/global.css';

function MrEgg() {
  return (
    <div className="body-container">
      <h1>mr. egg and friends</h1>
      <h4>Nov 2019 - Dec 2019</h4>
      <h2>Explore the project <a href='https://tangmonica.github.io/mr.egg/' target="_blank" rel="noopener noreferrer">here</a> and the code <a href='https://github.com/tangmonica/mr.egg' target="_blank" rel="noopener noreferrer">here</a>.</h2>
      <p>A website made with three.js that displays 3D models and allows users to interactively rotate and scale the models for viewing. </p>
      <img src={require('./mr-egg-site.png')} />
    </div>
  );
};

export default MrEgg
;
